import dynamic from 'next/dynamic';

export { EditorMode } from './mode';

export default dynamic(import('./Editor'), { ssr: false });
